import React, { useState } from 'react';
import useInView from './useInView';

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', org: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [leftRef, leftIn] = useInView();
  const [rightRef, rightIn] = useInView();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
  };

  const inputStyle = {
    background: '#f0f5ff', border: '1px solid #ccd9f0',
    border: '1px solid rgba(255,255,255,0.22)',
    color: '#0d2144', padding: '0.8rem 1rem',
    fontFamily: "'Barlow', sans-serif", fontSize: '0.9rem',
    width: '100%', transition: 'border-color 0.2s', outline: 'none',
  };

  return (
    <section id="contact" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
      {/* Left — info */}
      <div ref={leftRef} style={{
        background: '#ffffff', padding: '7rem 5rem',
        opacity: leftIn ? 1 : 0, transform: leftIn ? 'none' : 'translateX(-30px)',
        transition: 'all 0.8s ease',
      }}>
        <div className="section-label light">Get In Touch</div>
        <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.5rem,4vw,3.5rem)', color: '#0d2144', lineHeight: 0.95, marginBottom: '1.2rem', letterSpacing: '0.02em' }}>
          Start Your<br /><span style={{ color: 'var(--blue)' }}>Project</span><br />Today
        </h2>
        <p style={{ fontSize: '0.95rem', color: '#0d2144', lineHeight: 1.8, maxWidth: 360, marginBottom: '0.5rem' }}>
          Government agencies, corporations, NGOs, or private clients — we bring the expertise and commitment to deliver on time, on budget.
        </p>

        <ul style={{ listStyle: 'none', marginTop: '2.5rem' }}>
          {[
            { icon: '📞', label: 'Phone', val: '08036407458' },
            { icon: '📍', label: 'Abuja Office', val: 'Suite A11, SAMTL Apartment, Umaru Dikko Street, Jabi, Abuja FCT' },
            { icon: '📍', label: 'Osun State Office', val: 'Flat 2 Kosemani Complex, Gbongan Ibadan Express Way, Osogbo, Osun State' },
            { icon: '🏛', label: 'Registration', val: 'RC: 700638 — Corporate Affairs Commission, Nigeria' },
          ].map((item, i) => (
            <li key={i} style={{
              display: 'flex', gap: '1rem', alignItems: 'flex-start',
              padding: '1rem 0', borderBottom: '1px solid rgba(26,79,156,0.2)',
              opacity: leftIn ? 1 : 0, transition: `opacity 0.4s ease ${0.2 + i * 0.1}s`,
            }}>
              <span style={{ fontSize: '1.1rem', flexShrink: 0, marginTop: 2 }}>{item.icon}</span>
              <div>
                <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#1a4f9c', display: 'block', marginBottom: '0.25rem' }}>{item.label}</span>
                <span style={{ fontSize: '0.9rem', color: '#0d2144', fontWeight: 400, lineHeight: 1.5 }}>{item.val}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Right — form */}
      <div ref={rightRef} style={{
        background: 'var(--blue)', padding: '7rem 5rem',
        opacity: rightIn ? 1 : 0, transform: rightIn ? 'none' : 'translateX(30px)',
        transition: 'all 0.8s ease 0.15s',
      }}>
        {submitted ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>✅</div>
            <h3 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.5rem', color: 'white', marginBottom: '1rem' }}>Enquiry Received!</h3>
            <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.7 }}>Thank you for reaching out. The Rigomich team will contact you within 24 hours.</p>
            <button onClick={() => setSubmitted(false)} className="btn-white" style={{ marginTop: '2rem' }}>Send Another</button>
          </div>
        ) : (
          <>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.2rem', color: '#0d2144', letterSpacing: '0.02em', marginBottom: '0.4rem' }}>Request a Quote</div>
            <p style={{ fontSize: '0.88rem', color: '#0d2144', marginBottom: '2rem' }}>Our team will respond within 24 hours.</p>

            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.8rem', marginBottom: '0.8rem' }}>
                {[{ name: 'name', label: 'Full Name', placeholder: 'Your full name', type: 'text' },
                  { name: 'phone', label: 'Phone Number', placeholder: '08XXXXXXXXX', type: 'tel' }].map(f => (
                  <div key={f.name}>
                    <label style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#0d2144', display: 'block', marginBottom: '0.3rem' }}>{f.label}</label>
                    <input type={f.type} name={f.name} placeholder={f.placeholder} value={form[f.name]} onChange={handleChange} required style={inputStyle}
                      onFocus={e => e.target.style.borderColor = 'white'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.22)'} />
                  </div>
                ))}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.8rem', marginBottom: '0.8rem' }}>
                {[{ name: 'email', label: 'Email Address', placeholder: 'your@email.com', type: 'email' },
                  { name: 'org', label: 'Organization', placeholder: 'Company / Agency / NGO', type: 'text' }].map(f => (
                  <div key={f.name}>
                    <label style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#0d2144', display: 'block', marginBottom: '0.3rem' }}>{f.label}</label>
                    <input type={f.type} name={f.name} placeholder={f.placeholder} value={form[f.name]} onChange={handleChange} style={inputStyle}
                      onFocus={e => e.target.style.borderColor = 'white'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.22)'} />
                  </div>
                ))}
              </div>
              <div style={{ marginBottom: '0.8rem' }}>
                <label style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#0d2144', display: 'block', marginBottom: '0.3rem' }}>Service Required</label>
                <select name="service" value={form.service} onChange={handleChange} style={{ ...inputStyle, cursor: 'pointer' }}>
                  <option value="">— Select a service —</option>
                  <option>Civil & Building Construction</option>
                  <option>Electrical & Mechanical Engineering</option>
                  <option>Borehole Drilling & Water Engineering</option>
                  <option>General Contracting</option>
                  <option>Multiple Services</option>
                </select>
              </div>
              <div style={{ marginBottom: '0.8rem' }}>
                <label style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#0d2144', display: 'block', marginBottom: '0.3rem' }}>Project Description</label>
                <textarea name="message" rows={4} placeholder="Briefly describe your project, location, and timeline..." value={form.message} onChange={handleChange} style={{ ...inputStyle, resize: 'vertical' }}
                  onFocus={e => e.target.style.borderColor = 'white'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.22)'} />
              </div>
              <button type="submit" style={{
                fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.9rem', fontWeight: 700,
                letterSpacing: '0.14em', textTransform: 'uppercase',
                padding: '1rem 2.5rem', background: 'var(--blue-deep)', color: 'white',
                border: 'none', cursor: 'pointer', marginTop: '0.5rem',
                transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '0.6rem',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#05101f'}
              onMouseLeave={e => e.currentTarget.style.background = 'var(--blue-deep)'}>
                Submit Enquiry
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
              </button>
            </form>
          </>
        )}
      </div>

      <style>{`
        @media (max-width: 900px) {
          #contact { grid-template-columns: 1fr !important; }
          #contact > div { padding: 4rem 1.5rem !important; }
          #contact form > div { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
